const themedefault = {
    primary: '#911313',
    secondary: '#ed7c19',
    btnprimary: '#911313',
};
export default themedefault